import { connect } from 'react-redux'
import Legend from '../components/Legend'
import { showLegendSelector } from '../redux/selector'

const mapStateToProps = (state, { show }) => ({
  show: show || showLegendSelector(state),
})

export default connect(mapStateToProps)(Legend)
